


























































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Utils } from '@/helper/utils';
import { EnvironmentName } from '@/helper/enum';

@Component({
  computed: {
    ...mapGetters({ pageTitle: 'getTitle' }),
  },
})
export default class AnonymousLayout extends Vue {
  public value: boolean = false;
  public buttonCount: number = 0;
  public mobileButtons: any[] = [];
  public renderButtons: any[] = [];
  public renderButtonGroup: any[] = [];
  public methodName: string = '';
  public item: any = {};
  public progress: boolean = false;
  public isShownTitle: boolean = false;
  public isShowButton: any = '';
  public footer:string;

  public created() {
    this.footer = Utils.AppEnvironmentTitle;
    
    this.renderButtons = [];
  }

  public updateToolBar(buttons): void {
    this.methodName = '';
    this.buttonCount = buttons.length;
    this.mobileButtons = buttons;
    this.renderButtons = buttons.filter((item) => {
      return item.type === 'button';
    });
    this.renderButtonGroup = buttons.filter((item) => {
      return item.type === 'button-group';
    });
  }

  public methodToCall(item): void {
    this.methodName = item.click;
    this.item = item;
  }

  public resetMethodName(methodName): void {
    this.methodName = '';
  }

  public mounted() {
    this.$store.dispatch('setPageTitle', this.$route.meta.title);
    const title = this.$route.meta.title;
    this.isShownTitle = title == 'errorScreens.unAuthorized' ? true : false;
    const token = localStorage.getItem('bearerToken');
    this.isShowButton = token != null ? false : true;
  }
}
